<template>
  <div class="page">
    <!-- 头部 -->
    <div class="page-header shadow">
      <div class="header-inner">
        <div class="label">服务单查询：</div>
        <div class="content">
          <el-input
            placeholder="请输入服务单流水号/车牌号查询"
            v-model="keyword"
          >
            <template slot="append"
              ><i class="el-icon-search" @click="handleSearh"></i
            ></template>
          </el-input>
        </div>
      </div>
    </div>

    <!-- 基本信息 -->
    <FoldedPanel :isActive="billDataFlagActive" :isClose="billDataFlagClose">
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu"></i>基本信息批改</span
          >
          <el-checkbox
            class="ml15"
            v-model="billDataFlag"
            @change="checkChange('billDataFlag')"
            >是否批改</el-checkbox
          >
        </div>
      </template>
      <el-form
        class="pt15"
        :model="formData.bill_data"
        inline
        :rules="rules"
        ref="bill_data"
        label-width="80px"
      >
        <el-form-item class="from-item--30" label="服务起期" prop="beginTime">
          <el-date-picker
            v-model="formData.bill_data.beginTime"
            type="datetime"
            placeholder="选择日期时间"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="batchChange('bill_data', 'beginTime', '服务起期')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="服务止期" prop="endTime">
          <el-date-picker
            v-model="formData.bill_data.endTime"
            type="datetime"
            placeholder="选择日期时间"
            :editable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="batchChange('bill_data', 'endTime', '服务止期')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="服务天数" prop="days">
          <!-- <el-input
            type="text"
            v-model="formData.bill_data.day"
            placeholder="请输入出单公司"
          ></el-input> -->
          {{
            $tools.getDaysBetween(
              formData.bill_data.beginTime,
              formData.bill_data.endTime
            )
          }}
        </el-form-item>
        <el-form-item class="from-item--30" label="出单公司" prop="orgNo">
          <el-cascader
            v-model="formData.bill_data.orgNo"
            :options="$store.state.app.orgList"
            :props="{
              children: 'children',
              label: 'orgName',
              value: 'id',
              checkStrictly: true,
              emitPath: false,
            }"
            @change="batchChange('bill_data', 'orgNo', '出单公司')"
          ></el-cascader>
        </el-form-item>
        <el-form-item class="from-item--30" label="业务员" prop="saleNo">
          <el-select
            v-model="formData.bill_data.saleNo"
            placeholder="请选择业务员"
            @change="batchChange('bill_data', 'saleNo', '业务员')"
            filterable
          >
            <el-option
              v-for="item in $store.state.app.salesmanList"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="交费方式" prop="payType">
          <el-select
            v-model="formData.bill_data.payType"
            placeholder="请选择交费方式"
            @change="batchChange('bill_data', 'payType', '交费方式')"
          >
            <!-- <el-option label="净费" :value="0"></el-option> -->
            <el-option label="全费" value="全费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="经办人" prop="HandlerNo">
          <el-select
            v-model="formData.bill_data.HandlerNo"
            placeholder="请选择经办人"
            @change="batchChange('bill_data', 'HandlerNo', '经办人')"
            filterable
          >
            <el-option
              v-for="item in $store.state.app.userList"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--100" label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="formData.bill_data.remark"
            placeholder="请输入备注"
            @change="batchChange('bill_data', 'remark', '备注')"
          ></el-input>
        </el-form-item>
      </el-form>
    </FoldedPanel>
    <!-- 车辆信息批改 -->
    <FoldedPanel :isActive="carDataFlagActive" :isClose="carDataFlagClose">
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu"></i>车辆信息批改</span
          >
          <el-checkbox
            class="ml15"
            v-model="carDataFlag"
            @change="checkChange('carDataFlag')"
            >是否批改</el-checkbox
          >
        </div>
      </template>
      <el-form
        :model="formData.car_data"
        inline
        :rules="rules"
        ref="car_data"
        label-width="100px"
        class="pt15"
      >
        <el-form-item
          class="from-item--30 has-btn"
          label="车牌号码"
          prop="carNo"
        >
          <el-input
            v-model="formData.car_data.carNo"
            placeholder="车牌号"
            @change="batchChange('car_data', 'carNo', '车牌号码')"
          />
          <!-- <el-button
              size="small"
              style="margin-left: 15px"
              type="primary"
              @click="handleSelectCar"
              >选择车辆</el-button
            > -->
        </el-form-item>
        <el-form-item class="from-item--30" label="发动机号" prop="engineNo">
          <el-input
            v-model="formData.car_data.engineNo"
            placeholder="发动机号"
            @change="batchChange('car_data', 'engineNo', '发动机号')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="车架号" prop="vin">
          <el-input
            v-model="formData.car_data.vin"
            placeholder="车架号"
            @change="batchChange('car_data', 'vin', '车架号')"
          />
        </el-form-item>
        <el-form-item class="from-item--32" label="初登日期" prop="beginDate">
          <el-date-picker
            v-model="formData.car_data.beginDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择初登日期"
            @change="batchChange('car_data', 'beginDate', '选择初登日期')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="from-item--30" label="使用性质" prop="usetype">
          <el-input
            v-model="formData.car_data.usetype"
            placeholder="使用性质"
            @change="batchChange('car_data', 'usetype', '使用性质')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="品牌型号" prop="brandType">
          <el-input
            v-model="formData.car_data.brandType"
            placeholder="品牌型号"
            @change="batchChange('car_data', 'brandType', '品牌型号')"
          />
        </el-form-item>
        <!-- <el-form-item class="from-item--30" label="车型" prop="carType">
            <el-input
              v-model="formData.car_data.carType"
              placeholder="车型"
              disabled
            />
          </el-form-item> -->
        <el-form-item
          class="from-item--30"
          label="核定载客"
          prop="passengerCount"
        >
          <el-input
            v-model="formData.car_data.passengerCount"
            placeholder="核定载客"
            @change="batchChange('car_data', 'passengerCount', '核定载客')"
          />
        </el-form-item>
        <el-form-item
          class="from-item--30"
          label="核定载质量"
          prop="loadWeight"
        >
          <el-input
            v-model="formData.car_data.loadWeight"
            placeholder="核定载质量"
            @change="batchChange('car_data', 'loadWeight', '核定载质量')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="新车价" prop="newPrice">
          <el-input
            v-model="formData.car_data.newPrice"
            placeholder="新车价"
            @change="batchChange('car_data', 'newPrice', '新车价')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="使用年数" prop="userYears">
          <el-input
            v-model="formData.car_data.userYears"
            placeholder="使用年数"
            @change="batchChange('car_data', 'userYears', '使用年数')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="车辆种类" prop="carType">
          <el-select
            v-model="formData.car_data.carType"
            placeholder="请选择车辆种类"
            @change="batchChange('car_data', 'carType', '车辆种类')"
            filterable
          >
            <el-option
              v-for="item in $store.state.app.carType"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
            class="from-item--30"
            label="历年状态"
            prop="accidentType"
          >
            <el-input
              v-model="formData.car_data.accidentType"
              placeholder="历年状态"
              @change="batchChange('car_data', 'accidentType', '历年状态')"
            />
          </el-form-item> -->
        <el-form-item class="from-item--30" label="实际参考价" prop="nowPrice">
          <el-input
            v-model="formData.car_data.nowPrice"
            placeholder="实际参考价"
            @change="batchChange('car_data', 'nowPrice', '实际参考价')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="行驶区域" prop="goArea">
          <el-input
            v-model="formData.car_data.goArea"
            placeholder="行驶区域"
            @change="batchChange('car_data', 'goArea', '行驶区域')"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="验车提示" prop="notice">
          <el-select
            v-model="formData.car_data.notice"
            placeholder="请选择验车提示"
            @change="batchChange('car_data', 'notice', '验车提示')"
            filterable
          >
            <el-option
              v-for="item in $store.state.app.checkInfo"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="from-item--30" label="参统年数" prop="insYears">
          <el-input
            v-model="formData.bill_data.insYears"
            placeholder="参统年数"
            @change="batchChange('bill_data', 'insYears', '参统年数')"
          />
        </el-form-item>

        <el-form-item
          class="from-item--30"
          label="补偿次数"
          prop="accidentCount"
        >
          <el-input
            v-model="formData.bill_data.accidentCount"
            placeholder="参统期补偿次数"
			@change="batchChange('bill_data', 'accidentCount', '补偿次数')"
          />
        </el-form-item>
		
		<el-form-item
		  class="from-item--30"
		  label="原始服务"
		  prop="originalBill"
		>
		  <el-input
		    v-model="formData.bill_data.originalBill"
		    placeholder="原始服务"
			@change="batchChange('bill_data', 'originalBill', '原始服务')"
		  />
		</el-form-item>
		
		<el-form-item
		  class="from-item--30"
		  label="原始折扣"
		  prop="originalRebate"
		>
		  <el-input
		    v-model="formData.bill_data.originalRebate"
		    placeholder="原始折扣"
			 @change="batchChange('bill_data', 'originalRebate', '原始折扣')"
		  />
		</el-form-item>
		
		<el-form-item class="from-item--30" label="车辆大类" prop="carBigType">
		  <el-select
		    v-model="formData.car_data.carBigType"
		    placeholder="请选择车辆大类"
		    filterable
			@change="batchChange('car_data', 'carBigType', '择车辆大类')"
		  >
		    <el-option
		      v-for="item in $store.state.app.carBigType"
		      :key="item.label"
		      :label="item.label"
		      :value="item.value"
		    ></el-option>
		  </el-select>
    </el-form-item>
    </el-form>
    </FoldedPanel>
    <!-- 关系人信息批改 -->
    <FoldedPanel :isActive="userDataFlagActive" :isClose="userDataFlagClose">
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu"></i>关系人信息批改</span
          >
          <el-checkbox
            class="ml15"
            v-model="userDataFlag"
            @change="checkChange('userDataFlag')"
            >是否批改</el-checkbox
          >
        </div>
      </template>
      <div class="pt15">
        <FoldedPanel
          v-for="(item, index) in collapseList"
          :key="item.title"
          :name="item.key"
          titleBg="#fff"
        >
          <template #title>
            <div class="panel-header">
              <span class="panel-header-text">
                <i class="icon el-icon-user"></i>{{ item.title }}
                <el-checkbox
                  v-if="typeof item.checkProp !== 'undefined'"
                  v-model="item.checkProp"
                  @change="(val) => handleSamePersonData(val, index)"
                >
                  同被服务人
                </el-checkbox>
              </span>
              <!-- <el-button
                type="text"
                size="mini"
                @click="handleSelectPerson(index)"
                ><i class="el-icon-user-solid"></i> 选择{{
                  item.title
                }}</el-button
              > -->
            </div>
          </template>
          <el-form
            class="panel-form"
            :model="formData.person_data[index]"
            inline
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
          >
            <el-form-item class="from-item--30" label="类型" prop="personType">
              <el-radio-group
                v-model="formData.person_data[index].isgroup"
                @change="
                  batchChange(
                    'person_data',
                    'isgroup',
                    item.title + '类型',
                    index
                  )
                "
              >
                <el-radio :label="0">个人</el-radio>
                <el-radio :label="1">团队</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="from-item--30" label="名称" prop="personName">
              <el-input
                v-model="formData.person_data[index].personName"
                placeholder="名称"
                @change="
                  batchChange(
                    'person_data',
                    'personName',
                    item.title + '名称',
                    index
                  )
                "
              />
            </el-form-item>
            <el-form-item class="from-item--30" label="证件号" prop="certNo">
              <el-input
                v-model="formData.person_data[index].certNo"
                placeholder="证件号"
                @change="
                  batchChange(
                    'person_data',
                    'certNo',
                    item.title + '证件号',
                    index
                  )
                "
              />
            </el-form-item>
            <el-form-item class="from-item--30" label="电话" prop="tel">
              <el-input
                v-model="formData.person_data[index].tel"
                placeholder="电话"
                @change="
                  batchChange('person_data', 'tel', item.title + '电话', index)
                "
              />
            </el-form-item>
            <el-form-item class="from-item--30" label="地址" prop="addr">
              <el-input
                v-model="formData.person_data[index].addr"
                placeholder="地址"
                @change="
                  batchChange('person_data', 'addr', item.title + '地址', index)
                "
              />
            </el-form-item>
            <el-form-item class="from-item--30" label="邮箱" prop="email">
              <el-input
                v-model="formData.person_data[index].email"
                placeholder="邮箱"
                @change="
                  batchChange(
                    'person_data',
                    'email',
                    item.title + '邮箱',
                    index
                  )
                "
              />
            </el-form-item>
          </el-form>
        </FoldedPanel>
      </div>
    </FoldedPanel>
    <!-- 服务明细信息批改 -->
    <FoldedPanel
      :isActive="detailDataFlagActive"
      :isClose="detailDataFlagClose"
    >
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu"></i>服务明细信息批改</span
          >
          <el-checkbox
            class="ml15"
            v-model="detailDataFlag"
            @change="checkChange('detailDataFlag')"
            >是否批改</el-checkbox
          >
        </div>
      </template>
      <div class="pt15">
        <FoldedPanel titleBg="#fff">
          <template #title>
            <span class="panel-header-text"
              ><i class="icon el-icon-menu">主服务类型</i></span
            >
          </template>
          <el-table :data="majorData" style="width: 100%">
            <el-table-column prop="isCheck" label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.isCheck"
                  @change="
                    (val) => {
                      detailTtemChange(scope.row, 'isCheck');
                      batchChange(
                        'detail_data',
                        'isCheck',
                        scope.row.name + scope.column.label,
                        scope.$index,
                        'majorData'
                      );
                    }
                  "
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="200" label="项目">
              <template slot-scope="scope">
                <div v-if="scope.row.type_id === 4 || scope.row.type_id === 8">
                  <span v-if="!scope.row.isCheck"
                    >{{ scope.row.name }}{{ scope.row.special_fee }}元/座
                    <span>
                      共{{
                        formData.car_data.passengerCount - 1 > 0
                          ? formData.car_data.passengerCount - 1
                          : 0
                      }}座</span
                    ></span
                  >

                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ scope.row.name }}
                    <el-select
                      v-model="scope.row.special_fee"
                      filterable
                      placeholder="万元"
                      @change="
                        (val) => {
                          detailTtemChange(scope.row, 'special_fee');
                          batchChange(
                            'detail_data',
                            'special_fee',
                            scope.row.name + scope.column.label,
                            scope.$index,
                            'majorData'
                          );
                        }
                      "
                    >
                      <el-option
                        v-for="item in $emun.seatOption"
                        :key="item.label"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                    <span
                      >共{{
                        formData.car_data.passengerCount - 1 > 0
                          ? formData.car_data.passengerCount - 1
                          : 0
                      }}座</span
                    >
                  </div>
                </div>
                <div v-else-if="scope.row.type_id === 1">
                  <span v-if="!scope.row.isCheck">{{
                    `${scope.row.name}  绝对免赔额 ${scope.row.special_fee}`
                  }}</span>
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ `${scope.row.name}  绝对免赔额` }}
                    <el-input
                      v-if="scope.row.type_id === 1"
                      v-model="scope.row.special_fee"
                      placeholder="元"
                      @change="
                        (val) => {
                          detailTtemChange(scope.row, 'special_fee');
                          batchChange(
                            'detail_data',
                            'special_fee',
                            scope.row.name + scope.column.label,
                            scope.$index,
                            'majorData'
                          );
                        }
                      "
                    ></el-input>
                  </div>
                </div>
                <div v-else>
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tcfee" label="服务额(元)">
              <template slot-scope="scope">
                <div v-if="scope.row.type_id === 4 || scope.row.type_id === 8">
                  {{
                    (
                      scope.row.special_fee *
                      (formData.car_data.passengerCount - 1 > 0
                        ? formData.car_data.passengerCount - 1
                        : 0)
                    ).toFixed(2)
                  }}元
                </div>
                <div v-else>
                  <span v-if="!scope.row.isCheck"
                    >{{ (scope.row.tcfee * 1).toFixed(2) }}元</span
                  >
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    <el-input
                      v-model="scope.row.tcfee"
                      placeholder="元"
                      @change="
                        (val) => {
                          detailTtemChange(scope.row, 'tcfee');
                          batchChange(
                            'detail_data',
                            'tcfee',
                            scope.row.name + scope.column.label,
                            scope.$index,
                            'majorData'
                          );
                        }
                      "
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bztcfee" label="标准服务费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.bztcfee * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.bztcfee"
                    placeholder="元"
                    @change="
                      (val) => {
                        detailTtemChange(scope.row, 'bztcfee');
                        batchChange(
                          'detail_data',
                          'bztcfee',
                          scope.row.name + scope.column.label,
                          scope.$index,
                          'majorData'
                        );
                      }
                    "
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="yjtcfee" label="应交服务费(元)">
              <template slot-scope="scope">
                {{
                  (formData.bill_data.cusRebate * scope.row.bztcfee).toFixed(2)
                }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <FoldedPanel titleBg="#fff">
          <template #title>
            <span class="panel-header-text"
              ><i class="icon el-icon-menu">附加服务类型</i></span
            >
          </template>
          <el-table :data="additionData" style="width: 100%">
            <el-table-column prop="isCheck" label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.isCheck"
                  @change="
                    (val) => {
                      detailTtemChange(scope.row, 'isCheck');
                      batchChange(
                        'detail_data',
                        'isCheck',
                        scope.row.name + scope.column.label,
                        scope.$index,
                        'additionData'
                      );
                    }
                  "
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="200" label="项目">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ scope.row.name }}</span>
                <div class="input-wrap" v-if="scope.row.isCheck">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tcfee" label="服务额(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.tcfee * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.tcfee"
                    placeholder="元"
                    @change="
                      (val) => {
                        detailTtemChange(scope.row, 'tcfee');
                        batchChange(
                          'detail_data',
                          'tcfee',
                          scope.row.name + scope.column.label,
                          scope.$index,
                          'additionData'
                        );
                      }
                    "
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bztcfee" label="标准服务费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.bztcfee * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.bztcfee"
                    placeholder="元"
                    @change="
                      (val) => {
                        detailTtemChange(scope.row, 'bztcfee');
                        batchChange(
                          'detail_data',
                          'bztcfee',
                          scope.row.name + scope.column.label,
                          scope.$index,
                          'additionData'
                        );
                      }
                    "
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="yjtcfee" label="应交服务费(元)">
              <template slot-scope="scope">
                {{ (scope.row.yjtcfee * 1).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <div class="panel-detail-footer mb15">
          <div class="panel-detail-footer-left">
            <div class="label">整单折扣：</div>
            <el-input
              v-model="formData.bill_data.cusRebate"
              placeholder="折扣"
              @change="
                () => {
                  batchChange('bill_data', 'cusRebate', '整单折扣');
                  detailTtemChange({}, 'cusRebate');
                }
              "
            ></el-input>
          </div>
          <div class="panel-detail-footer-right">
            <span class="mr15">标准服务费合计：{{ standardTotal }}元</span>
            <span>应交服务费合计：{{ practicalTotal }}元</span>
          </div>
        </div>
		<div class="panel-detail-footer mb15">
			<div class="panel-detail-footer-left">
				<div class="label">客户折扣：</div>
				<el-input
				  v-model="formData.bill_data.customerRebate"
				  placeholder="折扣"
				  @change="
				    () => {
				      batchChange('bill_data', 'customerRebate', '客户折扣');
				      detailTtemChange({}, 'customerRebate');
				    }
				  "
				></el-input>
			</div>
		  <div class="panel-detail-footer-right">
		    <span class="mr15">客户服务费：{{ formData.bill_data.customerFee }}元</span>
		  </div>
		</div>
		
      </div>
    </FoldedPanel>
    <!-- 附件信息批改 -->
    <FoldedPanel :isActive="encDataFlagActive" :isClose="encDataFlagClose">
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu"></i>附件信息批改</span
          >
          <el-checkbox
            class="ml15"
            v-model="encDataFlag"
            @change="checkChange('encDataFlag')"
            >是否批改</el-checkbox
          >
        </div>
      </template>
      <div class="pt15">
        <el-card
          size="small"
          class="box-card"
          v-for="(item, index) in encList"
          :key="index"
        >
          <template slot="header">
            <div class="enc">
              <div class="encTitle">
                <i class="el-icon-info"></i>
                <span>{{ item.title }}</span>
              </div>
              <div class="encNum">
                <span>{{ item.fileList.length }}/{{ item.max }}</span>
                张文件
              </div>
            </div>
          </template>
          <div class="img-list">
            <el-upload
              :action="$settings.uploadUrl.img + '/admin/upload/upimg'"
              name="img"
              :data="{
                path: 20,
              }"
              :headers="{
                token: getToken(),
              }"
              list-type="picture-card"
              :file-list="item.fileList"
              :limit="item.max"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (file, fileList) => handleRemoveImg(file, fileList, item)
              "
              :on-success="(res) => uploadSuccess(res, item)"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div v-if="item.thumbnail" class="eg-img">
              <span>示例：</span>
              <el-image
                style="width: 100px; height: 100px"
                :src="item.thumbnail"
                :preview-src-list="[item.thumbnail]"
              >
              </el-image>
            </div>
          </div>
        </el-card>
      </div>
    </FoldedPanel>
    <!-- 特别约定批改 -->
    <FoldedPanel :isActive="tmpDataFlagActive" :isClose="tmpDataFlagClose">
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu"></i>特别约定批改</span
          >
          <el-checkbox
            class="ml15"
            v-model="tmpDataFlag"
            @change="checkChange('tmpDataFlag')"
            >是否批改</el-checkbox
          >
        </div>
      </template>
      <!-- <el-button class="select-btn" type="primary" @click="handleSelectTemp"
          >选择模版</el-button
        > -->
      <div class="pt15 mb15">
        <el-input
          v-model="formData.bill_data.specialRemark"
          type="textarea"
          :rows="4"
          placeholder="请输入特别约定"
          @change="batchChange('bill_data', 'specialRemark', '特别约定')"
        >
        </el-input>
      </div>
    </FoldedPanel>

    <FoldedPanel>
      <template #title>
        <div>
          <span class="panel-header-text"
            ><i class="icon el-icon-menu">批单备注{{isShowBtn}}</i></span
          >
        </div>
      </template>
      <div class="pt15 mb15">
        <el-input
          v-model="formData.data.pd_remark"
          type="textarea"
          :rows="4"
          placeholder="请输入批单备注"
        />
      </div>
    </FoldedPanel>
    <div v-if="isShowBtn > 0" class="confirm">
      <!-- <el-button type="primary" @click="saveInfo">保存</el-button> -->
      <el-button type="primary" @click="handleBatch">保存服务单信息</el-button>
      <el-button type="info" @click="resetInfo">重置</el-button>
    </div>
    <!-- <el-drawer
      :title="drawerCfg.title"
      :visible.sync="drawerCfg.visiable"
      direction="rtl"
      :close="drawerClosed"
      :size="drawerCfg.size"
      destroy-on-close
    > -->
    <!-- 选择车辆相关 -->
    <!-- <div class="drawer-content" v-if="drawerFlag === 'selectCar'">
        <BaseSearch
          v-model="carSearchData"
          :formOptions="carSearchFormOption"
          @handleSearch="handleTableSearch"
          labelWidth="70px"
        >
        </BaseSearch>
        <el-button type="primary" @click="handleAddCar"> + 新增</el-button>
        <BaseTable
          ref="baseTable"
          url="/admin/car/index"
          :tableData.sync="carTableData"
          :columns="carColumns"
          :searchParams="carSearchData"
        >
          <template #custom="{ scope }">
            {{ scope.row.title }}
          </template>
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="handleEditCar(row)"
              >编辑</el-button
            >
            <el-button type="text" size="mini" @click="handleSelectOneCar(row)"
              >选择车辆</el-button
            >
          </template>
        </BaseTable>
      </div> -->

    <!-- 选择关系人相关 -->
    <!-- <div class="drawer-content" v-if="drawerFlag === 'selectPerson'">
        <BaseSearch
          v-model="personSearchData"
          :formOptions="personSearchFormOption"
          @handleSearch="handleTableSearch"
          labelWidth="70px"
        >
        </BaseSearch>
        <el-button type="primary" @click="handleAddPerson"> + 新增</el-button>
        <BaseTable
          ref="baseTable"
          url="/admin/person/index"
          :tableData.sync="personTableData"
          :columns="personColumns"
          :searchParams="personSearchData"
        >
          <template #custom="{ scope }">
            {{ scope.row.title }}
          </template>
          <template #handle="{ row }">
            <el-button type="text" size="mini" @click="handleEditPerson(row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="handleSelectOnePerson(row)"
              >选择关系人</el-button
            >
          </template>
        </BaseTable>
      </div> -->

    <!-- 特别约定相关 -->
    <!-- <div class="drawer-content" v-if="drawerFlag === 'selectTemp'">
        <BaseTable
          ref="baseTable"
          url="/admin/special/index"
          :tableData.sync="tempTableData"
          :columns="tempColumns"
          :hasSelection="true"
          :hasIndex="false"
          @handleSelectionChange="handleSelectionChange"
        ></BaseTable>
        <el-button type="primary" @click="handleDialogComfirm">保存</el-button>
      </div>
    </el-drawer>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="30%"
      @close="dialogClosed"
    >
      <BaseForm
        v-if="drawerFlag === 'selectCar'"
        ref="baseForm"
        v-model="carFormData"
        :rules="carRules"
        :formOptions="carFormOption"
        labelWidth="120px"
      ></BaseForm>
      <BaseForm
        v-if="drawerFlag === 'selectPerson'"
        ref="baseForm"
        v-model="personFormData"
        :rules="personRules"
        :formOptions="personFormOption"
        labelWidth="120px"
      ></BaseForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDialogComfirm">确 定</el-button>
      </span>
    </el-dialog> -->
    <el-dialog title="批文提示" :visible.sync="patchDialogVisible" width="30%">
      <div v-html="batchStr"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="patchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchConfrim">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { rules } from "./rules";
import { carFormOption } from "@/views/basics/car/formOptions";
import { columns as carColumns } from "@/views/basics/car/columns";
import { searchFormOption as carSearchFormOption } from "@/views/basics/car/formOptions";
import { rules as carRules } from "@/views/basics/car/rules";

import { personFormOption } from "@/views/basics/privy/formOptions";
import { columns as personColumns } from "@/views/basics/privy/columns";
import { searchFormOption as personSearchFormOption } from "@/views/basics/privy/formOptions";
import { rules as personRules } from "@/views/basics/privy/rules";

import { columns as tempColumns } from "@/views/system/agreement/columns";

export default {
  name: "Recording",
  comments: {},
  data() {
    return {
      isUpdated: false,
      correctId: null,
      type: 1, // 1是新增 2是编辑
	  isShowBtn: 0, //是否显示保存按钮
      patchDialogVisible: false,
      // 复选框选中状态
      billDataFlag: true,
      carDataFlag: false,
      userDataFlag: false,
      detailDataFlag: false,
      encDataFlag: false,
      tmpDataFlag: false,
      // 折叠面板是否可展开
      billDataFlagActive: true,
      carDataFlagActive: true,
      userDataFlagActive: true,
      detailDataFlagActive: true,
      encDataFlagActive: true,
      tmpDataFlagActive: true,
      // 折叠面板打开状态
      billDataFlagClose: false,
      carDataFlagClose: true,
      userDataFlagClose: true,
      detailDataFlagClose: true,
      encDataFlagClose: true,
      tmpDataFlagClose: true,
      keyword: "",
      standardTotal: 0, // 标准合计
      practicalTotal: 0, // 应交合计
      selections: [],
      formData: {
        //主要信息
        bill_data: {
          cusRebate: 1,
          payType: "全费",
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
        },
        //人员关系信息
        person_data: [
          {
            personType: 0,
            isgroup: 0,
          },
          {
            personType: 1,
            isgroup: 0,
          },
          {
            personType: 2,
            isgroup: 0,
          },
        ],
        //附件信息
        enc_data: [],
        //服务详细信息
        detail_data: {},
        // 特别约定
        template_data: {
          content: "",
        },
        data: {
          insBillId: "",
          piwen: "",
          pd_remark: "",
        },
      },
      // 附件相关
      identityPhoto: [],
      drivingPhoto: [],
      businessPhoto: [],
      paymentPhoto: [],
      dangerNum: [],
      validatePhoto: [],
      standardPhoto: [],
      otherPhoto: [],
      activeCollapseNames: [1],
      planCollapseNames: [1],
      // 抽屉相关
      drawerCfg: {
        title: "",
        visiable: false,
        size: "40%",
      },
      drawerFlag: "",
      // 弹框相关
      dialogVisible: false,
      dialogTitle: "新增车辆信息",
      // 选择车辆相关
      carFormData: {},
      carSearchData: {},
      carTableData: [],
      carSubmitFlag: "add",
      // 选择人物相关
      personFormData: {},
      personSearchData: {},
      personTableData: [],
      personSubmitFlag: "add",
      collapseList: [
        {
          title: "被服务人",
          key: 0,
        },
        {
          title: "参统人",
          key: 1,
          checkProp: false,
        },
        {
          title: "车主",
          key: 2,
          checkProp: false,
        },
      ],
      // 选择模版相关
      tempTableData: [],
      // 主服务列表信息
      majorData: [],
      // 附加服务列表信息
      additionData: [],
      // 备份数据
      copyFormData: {},
      // 批文数据
      patchFormData: {
        bill_data: [],
        car_data: [],
        person_data: [],
        detail_data: [],
      },
      batchStr: "",
      rules: rules(this),
    };
  },
  computed: {
    /**
     * 车辆相关
     */
    carFormOption,
    carColumns, // 车辆列信息
    carSearchFormOption, // 车辆搜索头部
    carRules,
    /**
     * 车辆相关结束
     */
    /**
     * 选择人物相关
     */
    personFormOption,
    personColumns, // 车辆列信息
    personSearchFormOption, // 车辆搜索头部
    personRules,
    /**
     * 选择人物结束
     */
    /**
     * 特别约定相关
     */
    tempColumns() {
      const col = tempColumns();
      col.splice(col.length - 1, 1);
      return col;
    },
    /**
     * 特别约定相关结束
     */
    // 附件相关
    encList() {
      //附件
      return [
        {
          title: "身份证",
          imageType: 1,
          max: 5,
          fileList: this.identityPhoto,
          prop: "identityPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/311586697b54e14da8be5966ca7cea82.jpg",
        },
        {
          title: "行驶证",
          imageType: 2,
          max: 5,
          fileList: this.drivingPhoto,
          prop: "drivingPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/93a43fbefc8c2f8ed032e7c02de34263.jpeg",
        },
        {
          title: "出险次数截图",
          imageType: 7,
          max: 5,
          fileList: this.dangerNum,
          prop: "dangerNum",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/7bacafadbbd691bb082253047c549380.jpeg",
        },
        {
          title: "营业执照",
          imageType: 3,
          max: 5,
          fileList: this.businessPhoto,
          prop: "businessPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/dceb23dcba4d1074288ec572e5c8c2f7.jpg",
        },
        {
          title: "支付凭证截图",
          imageType: 8,
          max: 5,
          fileList: this.paymentPhoto,
          prop: "paymentPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/44dddf01e40f0c98a46a6a7256cb84ef.jpeg",
        },
        {
          title: "验车照片",
          imageType: 4,
          max: 5,
          fileList: this.validatePhoto,
          prop: "validatePhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/06d2b326be98531b3a74a1fd58a426e4.jpg",
        },
        {
          title: "标准费用参考图",
          imageType: 5,
          max: 5,
          fileList: this.standardPhoto,
          prop: "standardPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220104/3c42b2fe8b113473cbc79f4997d939ba.png",
        },
        {
          title: "其他",
          imageType: 6,
          max: 8,
          fileList: this.otherPhoto,
          prop: "otherPhoto",
        },
      ];
    },
  },
  watch: {
    $route: {
      async handler(val) {
        const { correctId,isShowBtn } = val.query;
		console.log(isShowBtn);
		this.isShowBtn = isShowBtn;
        if (correctId) {
          this.correctId = correctId;
          await this.getOwnerDetailList();
          await this.handleSearh();
        }
      },
      deep: true,
      immediate: true,
    },
    isUpdated() {
      console.log(this.$data, "---------this.data");
    },
  },
  created() {
    if (!this.correctId) {
      this.getOwnerDetailList();
    }
    this.$store.dispatch("app/getCarType");
	this.$store.dispatch("app/getCarBigType");
	// 验车提示
	this.$store.dispatch("app/getCheckInfo");
  },
  methods: {
    getToken,
    // 获取统主筹明细列表
    async getOwnerDetailList() {
      const res = await this.$api.post("/admin/other/get_detail_type");
      console.log(res);
      this.majorData = res.data.map((item) => {
        item = {
          ...item,
          isCheck: false,
          special_fee: 0, // 项目列里可输入字段
          tcfee: 0, // 服务额
          bztcfee: 0, // 标准服务费
          yjtcfee: 0, // 应缴金额
          discount: 1, // 折扣
          type_id: item.id,
          type_pid: item.pid,
        };
        return item;
      });

      console.log(this.majorData, this.additionData, "tongchoulieixng");
    },
    // 根据父级id获取子级附加类型明细数据
    async getAttchDetaiList(type_id) {
      const res = await this.$api.post("/admin/other/get_detail_son_type", {
        type_id,
      });
      const list = res.data.map((item) => {
        item = {
          ...item,
          isCheck: false,
          special_fee: 0, // 项目列里可输入字段
          tcfee: 0, // 服务额
          bztcfee: 0, // 标准服务费
          yjtcfee: 0, // 应缴金额
          discount: 1, // 折扣
          type_id: item.id,
          type_pid: item.pid,
        };
        return item;
      });
      this.additionData = [...this.additionData, ...list];
      //console.log(this.additionData);
    },
    // 回显信息
    async handleSearh() {
      let url = "";
      let params = {};
      if (this.correctId) {
        url = "/admin/correct/getinfo";
        params = {
          correctId: this.correctId,
        };
      } else if (this.keyword) {
        url = "/admin/insbill/getTheDetail";
        params = {
          keyword: this.keyword,
        };
      }
      const res = await this.$api.post(url, params);
      // 回显基本信息
      const billData = {
        ...res.data.base,
      };
      // 回显车辆信息
      const carData = {
        ...res.data.car,
      };
      // 回显关系人信息
      const personData = [...res.data.person];
      this.identityPhoto = [];
      this.drivingPhoto = [];
      this.businessPhoto = [];
      this.validatePhoto = [];
      this.standardPhoto = [];
      this.otherPhoto = [];
      this.dangerNum = [];
      this.paymentPhoto = [];
      // 回显附件信息
      res.data.enc.forEach((ele) => {
        if (ele.imageType === 1) {
          this.identityPhoto.push(ele);
        }
        if (ele.imageType === 2) {
          this.drivingPhoto.push(ele);
        }
        if (ele.imageType === 3) {
          this.businessPhoto.push(ele);
        }
        if (ele.imageType === 4) {
          this.validatePhoto.push(ele);
        }
        if (ele.imageType === 5) {
          this.standardPhoto.push(ele);
        }
        if (ele.imageType === 6) {
          this.otherPhoto.push(ele);
        }
        if (ele.imageType === 7) {
          this.dangerNum.push(ele);
        }
        if (ele.imageType === 8) {
          this.paymentPhoto.push(ele);
        }
      });
      this.majorData = this.majorData.map((ele) => {
        ele.isCheck = false;
        res.data.item.forEach((element) => {
          if (element.type_id === ele.type_id) {
            ele = {
              ...element,
              isCheck: true,
            };
          }
        });
        return ele;
      });
	  this.additionData = [];
      res.data.item.forEach((element) => {
        if (element.type_pid) {
          this.additionData.push({ ...element, isCheck: true });
        }
      });
      this.standardTotal = res.data.base.contractFee || 0;
      this.practicalTotal = res.data.base.cusFee || 0;

      //console.log(this.majorData);
      this.formData = {
        bill_data: {
          ...billData,
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
          ...carData,
        },
        //人员关系信息
        person_data: [...personData],
        //附件信息
        enc_data: [...res.data.enc],
        //服务详细信息
        detail_data: [
          // ...res.data.item
          ...this.majorData,
          ...this.additionData,
        ],
        data: {
          pd_remark: res.data.base.pd_remark || "",
        },
      };

      console.log(this.formData);
      // this.formData.bill_data
      this.copyFormData = this.$tools.deepClone(this.formData);
      this.isUpdated = true;
      console.log(this.copyFormData);
    },

    // 回显批单=

    // 复选框change
    checkChange(prop) {
      // this[prop] = !this[prop]
      if (!this[prop]) {
        this[`${prop}Active`] = true;
        this[`${prop}Close`] = true;
      } else {
        this[`${prop}Active`] = false;
        this[`${prop}Close`] = false;
      }
      console.log(prop);
    },

    // 批文检测
    batchChange(parentProp, key, label, index, detailType) {
      console.log(parentProp, key, label, index);
      // 如果index为undefined类型，证明父级是对象否则是数组
      if (typeof index === "undefined") {
        // 如果新改的数据和历史数据不一样，批文存一条信息
        console.log(
          this.formData[parentProp][key],
          this.copyFormData[parentProp][key],
          "this.formData[parentProp][key] !== this.copyFormData[parentProp][key]"
        );
        if (
          this.formData[parentProp][key] !== this.copyFormData[parentProp][key]
        ) {
          const patchItemIndex = this.hasBatch(parentProp, key);
          console.log(patchItemIndex, "是否为-1");
          if (patchItemIndex !== -1) {
            this.patchFormData[parentProp][patchItemIndex] = {
              key,
              label,
              before: this.copyFormData[parentProp][key],
              after: this.formData[parentProp][key],
            };
          } else {
            console.log("");
            this.patchFormData[parentProp].push({
              key,
              label,
              before: this.copyFormData[parentProp][key],
              after: this.formData[parentProp][key],
            });
          }
        } else {
          // 如果一样，将批文已存在的key的信息去掉
          this.patchFormData[parentProp] = this.patchFormData[
            parentProp
          ].filter((item) => item.key !== key);
        }
      } else {
        console.log(this.copyFormData, parentProp, index, key);
        // console.log(this.formData[parentProp][index][key], this.copyFormData[parentProp][index][key], 'this.copyFormData[parentProp][index][key]')
        // 修改信息为服务类型
        if (parentProp === "detail_data") {
          // 首先判断是否是新增的明细内容
          // 根据索引找到主服务类型/附加服务类型的子项
          const newItem = this[detailType].find((item, ind) => index === ind);
          // 根据子项type_id 来确定是copy数据的哪一项
          // const copyItem = Array.from(this.copyFormData[parentProp]).find(item => item.type_id === newItem.type_id)
          const patchIndex = Array.from(
            this.patchFormData[parentProp]
          ).findIndex((item) => item.type_id === newItem.type_id);
          const copyIndex = Array.from(this.copyFormData[parentProp]).findIndex(
            (item) => item.type_id === newItem.type_id
          );
          // 如果在批文信息里面已经存在这条信息
          if (this.patchFormData[parentProp][patchIndex]) {
            this.patchFormData[parentProp][patchIndex] = {
              key,
              label,
              before: this.copyFormData[parentProp][copyIndex]
                ? this.copyFormData[parentProp][copyIndex][key]
                : "",
              after: this[detailType][index][key],
            };
          } else {
            this.patchFormData[parentProp].push({
              key,
              label,
              before: this.copyFormData[parentProp][copyIndex]
                ? this.copyFormData[parentProp][copyIndex][key]
                : "",
              after: this[detailType][index][key],
            });
          }
          console.log("不管修改还是新增", this.patchFormData);
          // 如果copyItem存在就是修改，否则就是新增
          // if(copyItem) {
          //   console.log('修改')

          // } else {
          //   console.log('新增')

          // }
          // if(this.copyFormData[parentProp][index]) {
          //   // 证明是明细详情原来的内容

          //   if(this.copyFormData[parentProp][index][key] !== this[detailType][index][key]) {

          //     if(patchItemIndex !== -1) {
          //       this.patchFormData[parentProp][patchItemIndex] = {
          //         key,
          //         label,
          //         before: this.copyFormData[parentProp][index][key],
          //         after: this[detailType][index][key]
          //       }
          //     } else {
          //       this.patchFormData[parentProp].push({
          //         key,
          //         label,
          //         before: this.copyFormData[parentProp][index][key],
          //         after: this[detailType][index][key]
          //       })
          //     }
          //   } else {
          //     this.patchFormData[parentProp] = this.patchFormData[parentProp].filter(item => item.key !== key)
          //   }
          // } else {
          //   console.log('新增的')
          // }
        } else {
          console.log(
            this.formData[parentProp][index][key],
            this.copyFormData[parentProp][index][key],
            "---------1321"
          );
          if (
            this.formData[parentProp][index][key] !==
            this.copyFormData[parentProp][index][key]
          ) {
            const patchItemIndex = this.hasBatch(parentProp, key, index);
            console.log(patchItemIndex, "是否存在批文");
            if (patchItemIndex !== -1) {
              this.patchFormData[parentProp][patchItemIndex] = {
                key,
                label,
                before: this.copyFormData[parentProp][index][key],
                after: this.formData[parentProp][index][key],
              };
            } else {
              this.patchFormData[parentProp].push({
                key,
                label,
                before: this.copyFormData[parentProp][index][key],
                after: this.formData[parentProp][index][key],
              });
            }
          } else {
            this.patchFormData[parentProp] = this.patchFormData[
              parentProp
            ].filter((item) => item.key !== key);
          }
        }
      }

      console.log(this.patchFormData);
    },

    // 检测批文信息是否已经存在
    hasBatch(parentProp, key, index) {
      let flag = -1;
      if (!index) {
        if (!this.patchFormData[parentProp]) {
          flag = -1;
        } else {
          flag = this.patchFormData[parentProp].findIndex(
            (item) => item.key === key
          );
        }
      } else {
        if (!this.patchFormData[parentProp][index]) {
          flag = -1;
        } else {
          flag = index;
        }
      }

      return flag;
    },

    /**
     * 选择车辆相关
     */
    // 选择车辆
    handleSelectCar() {
      this.drawerFlag = "selectCar";
      this.drawerCfg = {
        title: "选择车辆信息",
        visiable: true,
        size: "60%",
      };
      this.handleTableSearch();
    },

    // 表格搜索
    handleTableSearch() {
      this.$nextTick(() => {
        this.$refs.baseTable.searchData();
      });
    },

    // 车辆新增
    handleAddCar() {
      this.dialogTitle = "新增车辆信息";
      this.dialogVisible = true;
      this.carSubmitFlag = "add";
    },

    // 点击编辑车辆
    handleEditCar(row) {
      console.log(row);
      this.dialogTitle = "编辑车辆信息";
      this.carSubmitFlag = "edit";
      this.dialogVisible = true;
      this.carFormData = {
        ...row,
      };
    },

    // 车辆信息提交
    handleCarSubmit() {
      console.log(this.carFormData, "-----------fsfsf");
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let msg = "";
              if (this.carSubmitFlag === "add") {
                msg = "新增车辆";
              } else {
                msg = "编辑车辆";
              }
              console.log(this.carFormData);
              await this.$api.post("/admin/car/save", this.carFormData, msg);
              this.dialogVisible = false;
              this.handleTableSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },

    // 选择了某一辆车辆
    handleSelectOneCar(row) {
      console.log(row);
      this.formData.car_data = {
        ...row,
      };
      this.drawerCfg.visiable = false;
    },

    /**
     * 车辆相关结束
     */

    /**
     * 关系人信息相关
     */
    // 选择关系人
    handleSelectPerson(index) {
      this.personIndex = index;
      this.drawerFlag = "selectPerson";
      this.drawerCfg = {
        title: "选择关系人",
        visiable: true,
        size: "60%",
      };
      this.handleTableSearch();
    },

    // 关系人同被服务人
    handleSamePersonData(val, index) {
      if (!val) return;
      this.formData.person_data = this.formData.person_data.map((item, ind) => {
        if (index === ind) {
          item = {
            ...item,
            ...this.formData.person_data[0],
            personType: item.personType,
          };
        }
        return item;
      });
    },

    // 人物新增
    handleAddPerson() {
      this.dialogTitle = "新增关系人信息";
      this.dialogVisible = true;
      this.personSubmitFlag = "add";
    },

    // 点击编辑人物
    handleEditPerson(row) {
      console.log(row);
      this.dialogTitle = "编辑关系人信息";
      this.personSubmitFlag = "edit";
      this.dialogVisible = true;
      this.personFormData = {
        ...row,
      };
    },

    // 人物信息提交
    handlePersonSubmit() {
      console.log(this.personFormData);
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let msg = "";
              if (this.personSubmitFlag === "add") {
                msg = "新增关系人";
              } else {
                msg = "编辑关系人";
              }

              console.log(this.personFormData);
              await this.$api.post(
                "/admin/person/save",
                this.personFormData,
                msg
              );
              this.dialogVisible = false;
              this.handleTableSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },

    // 选择了某一个人
    handleSelectOnePerson(row) {
      console.log(row);
      this.formData.person_data = this.formData.person_data.map(
        (item, index) => {
          if (this.personIndex === index) {
            item = {
              ...item,
              ...row,
            };
          }
          return item;
        }
      );
      this.drawerCfg.visiable = false;
    },
    /**
     * 关系人信息相关结束
     */

    /**
     * 服务明细相关
     */
    detailTtemChange(row, prop) {
      // 父级选中，请求子级数据
      console.log(row);
      if (row.type_pid === 0 && prop === "isCheck" && row.isCheck) {
        // 添加附加服务类型
        this.getAttchDetaiList(row.type_id);
      } else if (row.type_pid === 0 && prop === "isCheck" && !row.isCheck) {
        // 删除附加服务类型
        this.additionData = this.additionData.filter(
          (item) => item.type_pid !== row.type_id
        );
      }
      this.standardTotal = 0;
      this.practicalTotal = 0;
      this.majorData = this.majorData.map((item) => {
        // 计算总价
        if (item.isCheck) {
          this.standardTotal += item.bztcfee * 1;
          this.practicalTotal +=
            item.bztcfee * 1 * this.formData.bill_data.cusRebate;
        }
        if (item.type_id === 4 || item.type_id === 8) {
          item.tcfee =
            item.special_fee *
            (this.formData.car_data.passengerCount - 1 > 0
              ? this.formData.car_data.passengerCount - 1
              : 0);
          console.log(
            item,
            this.formData.car_data.passengerCount - 1 > 0
              ? this.formData.car_data.passengerCount - 1
              : 0
          );
        }
        item.yjtcfee = this.formData.bill_data.cusRebate * item.bztcfee;
        return item;
      });
      this.additionData = this.additionData.map((item) => {
        if (item.isCheck) {
          this.standardTotal += item.bztcfee * 1;
          this.practicalTotal +=
            item.bztcfee * 1 * this.formData.bill_data.cusRebate;
        }
        item.yjtcfee = this.formData.bill_data.cusRebate * item.bztcfee;
        return item;
      });
      this.standardTotal = this.standardTotal.toFixed(2);
      this.practicalTotal = this.practicalTotal.toFixed(2);
	  // 客户服务费
	  this.formData.bill_data.customerFee = (this.standardTotal * this.formData.bill_data.customerRebate).toFixed(2);
    },
    /**
     * 服务明细相关结束
     */
    /**
     * 特别约定相关开始
     */
    // 选择特别约定
    handleSelectTemp(index) {
      this.personIndex = index;
      this.drawerFlag = "selectTemp";
      this.drawerCfg = {
        title: "选择特别约定",
        visiable: true,
        size: "40%",
      };
      this.handleTableSearch();
    },

    // 选择模版
    handleSelectionChange(selections) {
      // 已选模版
      this.selections = selections;
      console.log(...arguments);
    },

    // 选择模版确定
    handleSelectTempComfrim() {
      this.selections.forEach((item) => {
        this.formData.bill_data.specialRemark += item.tyContent;
      });
      this.drawerCfg.visiable = false;
    },
    /**
     * 特别约定相关结束
     */
    // 点击弹框/点击保存
    handleDialogComfirm() {
      console.log(this.drawerFlag);
      switch (this.drawerFlag) {
        case "selectCar":
          this.handleCarSubmit();
          break;
        case "selectPerson":
          this.handlePersonSubmit();
          break;
        case "selectTemp":
          this.handleSelectTempComfrim();
          break;

        default:
          break;
      }
    },
    // 图片上传之前
    handlePictureCardPreview(file) {
      console.log(file);
    },
    // 删除图片
    handleRemoveImg(res, fileList, item) {
      this[item.prop] = this[item.prop].filter((el) => el.url !== res.url);
    },

    uploadSuccess(res, item) {
      if (res.code === 10000) {
        this.$message.success("上传成功");
        console.log(item);
        // itle: "其他",
        //   imageType: 6,
        //   max: 8,
        //   fileList: this.otherPhoto,
        //   porp: 'otherPhoto'
        console.log(item.prop, this.identityPhoto);
        this[item.prop].push({
          imageType: item.imageType,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      console.log(...arguments);
    },

    // 抽屉关闭之后
    drawerClosed() {},
    handleBatch() {
      this.batchStr = "";
      if (this.billDataFlag || this.tmpDataFlag) {
        this.patchFormData.bill_data.forEach((item) => {
          const str = `<div class="mb15">${item.label} 由 ${item.before} ==> ${item.after}</div>`;
          this.batchStr += str;
        });
      }

      if (this.carDataFlag) {
        this.patchFormData.car_data.forEach((item) => {
          const str = `<div class="mb15">${item.label} 由 ${item.before} ==> ${item.after}</div>`;
          this.batchStr += str;
        });
      }
      if (this.userDataFlag) {
        this.patchFormData.person_data.forEach((item) => {
          const str = `<div class="mb15">${item.label} 由 ${item.before} ==> ${item.after}</div>`;
          this.batchStr += str;
        });
      }
      if (this.detailDataFlag) {
        this.patchFormData.detail_data.forEach((item) => {
          const str = `<div class="mb15">${item.label} 由 ${
            typeof item.before === "boolean"
              ? item.before
                ? "选择"
                : "未选择"
              : item.before
          } ==> ${
            typeof item.after === "boolean"
              ? item.after
                ? "选择"
                : "未选择"
              : item.after
          }</div>`;
          this.batchStr += str;
        });
      }
	  if (this.encDataFlag) {
	     this.batchStr += '附件信息修改';
	  }
	  
      if (!this.batchStr) {
        this.$message.warning("您没有对当前服务单做修改！");
        return;
      }
      this.patchDialogVisible = true;
    },
    async resetInfo() {
      const res = await this.$confirm("重置将会清空您填的数据，是否确认？");
      if (res !== "confirm") return;
      this.formData = {
        //主要信息
        bill_data: {
          cusRebate: 1,
          specialRemark: "",
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
        },
        //人员关系信息
        person_data: [
          {
            personType: 0,
            isgroup: 0,
          },
          {
            personType: 1,
            isgroup: 0,
          },
          {
            personType: 2,
            isgroup: 0,
          },
        ],
        //附件信息
        enc_data: [],
        //服务详细信息
        detail_data: {},
      };
      this.identityPhoto = [];
      this.drivingPhoto = [];
      this.businessPhoto = [];
      this.validatePhoto = [];
      this.standardPhoto = [];
      this.otherPhoto = [];
      this.dangerNum = [];
      this.getOwnerDetailList();
      this.additionData = [];
    },
    // handleBatchConfrim
    handleBatchConfrim() {
      this.saveInfo();
    },
    // 处理服务明细提交时的数据
    transDetailData(key) {
      return this[key]
        .filter((item) => item.isCheck)
        .map((item) => {
          if (item.isCheck) {
            item.type_id =
              typeof item.type_id === "undefined" ? item.id : item.type_id;
            item.type_pid =
              typeof item.type_pid === "undefined" ? item.pid : item.type_pid;
            return item;
          } else {
            return null;
          }
        });
    },

    validate(flag) {
      return new Promise((resolve, reject) => {
        this.$refs[flag].validate((vali) => {
          if (vali) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },

    //保存服务信息
    async saveInfo() {
      let isValid = false;

      Object.assign(this.formData.bill_data, {
        standardTotal: this.standardTotal,
        practicalTotal: this.practicalTotal,
        beginTime: this.$moment(this.formData.bill_data.beginTime)
          .utcOffset(8)
          .format("YYYY-MM-DD HH:mm:ss"),
        endTime: this.$moment(this.formData.bill_data.endTime)
          .utcOffset(8)
          .format("YYYY-MM-DD HH:mm:ss"),
      });
      isValid = await this.validate("bill_data").catch(() => {});
      if (!isValid) {
        this.$message.warning("请完善基本信息");
        return;
      }
      isValid = await this.validate("car_data").catch(() => {});
      if (!isValid) {
        this.$message.warning("请完善车辆信息");
        return;
      }
      if (!(this.formData.bill_data.accidentCount >= 0)) {
        this.$message.warning("请完善车辆信息-补偿次数信息");
        return;
      }
      // if (!this.paymentPhoto.length) {
      //   this.$message.warning("请完善附件信息-支付凭证信息");
      //   return;
      // }

      // 归档同凑明细提交数据
      const majorData = this.transDetailData("majorData");
      const additionData = this.transDetailData("additionData");
      this.formData.detail_data = [...majorData, ...additionData];

      // 附件信息处理
      this.formData.enc_data = [
        ...this.identityPhoto,
        ...this.drivingPhoto,
        ...this.businessPhoto,
        ...this.paymentPhoto,
        ...this.validatePhoto,
        ...this.standardPhoto,
        ...this.otherPhoto,
        ...this.dangerNum,
      ];

      const data = {
        insBillId: this.insBillId,
        piwen: this.batchStr,
        pd_remark: this.formData.data.pd_remark,
      };
      const msg = this.insBillId ? "保存" : "保存";
      // insBillId 如果是0是新增、编辑
      if (isValid) {
        let query = await this.$api.post(
          "/admin/correct/saveall",
          {
            type: this.correctId ? 2 : 1,
            ...this.formData,
            insBillId: this.formData.bill_data.insBillId || 0,
            data,
          },
          msg
        );
        if (!query) return;
        this.$router.push({
          path: "/correct/endorsement",
        });
      }
    },

    //修改服务信息
    updataInfo() {},

    // 弹框关闭
    dialogClosed() {
      this.carFormData = {};
      this.$refs.baseForm.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;
  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 10px;
    margin-bottom: 20px;
    .header-inner {
      width: 40%;
      display: flex;
      align-items: center;
      .content {
        flex: 1;
      }
    }
  }
  .panel-header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    .panel-header-text {
      .icon {
        color: #666;
        margin-right: 10px;
      }
    }
  }
  .panel-form {
    padding: 20px;
  }

  .base-info {
    padding: 15px;
  }

  .card-info {
    margin-top: 15px;
  }
  .collapse-title {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      color: #666;
      .icon {
        margin-right: 5px;
        margin-top: 3px;
      }
    }
    .title-right {
      margin-right: 10px;
    }
  }
  :deep(.el-card) {
    margin-bottom: 15px;
  }
  :deep(.el-card__header) {
    padding: 10px;
  }
  :deep(.el-card__body) {
    padding: 15px;
  }
}
.select-btn {
  margin-bottom: 15px;
}
.page :deep(.el-form) {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    display: flex;
    .el-form-item__label {
      flex-shrink: 0;
    }
    .el-form-item__content {
      flex: 1;
    }
  }
  .el-input {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
}
.from-item--30 {
  width: 24%;
}
.has-btn {
  :deep(.el-form-item__content) {
    display: flex;
  }
}
.from-item--100 {
  width: 100%;
}
.confirm {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.enc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .encTitle {
    & > span {
      margin-left: 15px;
      font-size: 16px;
      color: #666;
    }
  }
  .encNum {
    font-size: 14px;
    color: #666;
    & > span {
      color: red;
      margin-right: 4px;
    }
  }
  .drawer-content {
    width: 100%;
    height: 100%;
  }
}
.input-wrap {
  display: flex;
  align-items: center;
  :deep( .el-input) {
    width: 90px;
    margin-left: 10px;
  }
}
.panel-detail-footer {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  .panel-detail-footer-left {
    display: flex;
    align-items: center;
    .label {
      white-space: nowrap;
    }
  }
}
.privy-box {
  padding-top: 15px;
}

.img-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .eg-img {
    // width: 100px;
    // height: 100px;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: flex-start;
  }
}
:deep(.el-icon-circle-close) {
  color: #ef6027;
}
</style>
